import { render, staticRenderFns } from "./PartnerNotificationEmailForm.vue?vue&type=template&id=06899f9a&scoped=true"
import script from "./PartnerNotificationEmailForm.vue?vue&type=script&lang=ts"
export * from "./PartnerNotificationEmailForm.vue?vue&type=script&lang=ts"
import style0 from "./PartnerNotificationEmailForm.vue?vue&type=style&index=0&id=06899f9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06899f9a",
  null
  
)

export default component.exports